const Images = {
    EventImg: require('./images/Vector.svg').default,
    logo:require('./images/logo.svg').default,
   
}
export default Images